import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, steps }) => {
  return (
    <div className="w-full mb-8 md:mb-10 lg:mb-12">
      <div className="flex items-center justify-between relative">
        {/* Progress Line */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-[var(--color-muted)]">
          <div 
            className="h-full bg-[var(--color-primary)] transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (steps?.length - 1)) * 100}%` }}
          />
        </div>

        {/* Steps */}
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isUpcoming = stepNumber > currentStep;

          return (
            <div key={step?.id} className="flex flex-col items-center relative z-10">
              {/* Step Circle */}
              <div
                className={`
                  w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full flex items-center justify-center
                  transition-all duration-300 border-2
                  ${isCompleted ? 'bg-[var(--color-primary)] border-[var(--color-primary)]' : ''}
                  ${isCurrent ? 'bg-[var(--color-card)] border-[var(--color-primary)] ring-4 ring-[var(--color-primary)]/20' : ''}
                  ${isUpcoming ? 'bg-[var(--color-card)] border-[var(--color-muted)]' : ''}
                `}
              >
                {isCompleted ? (
                  <Icon name="Check" size={20} color="var(--color-primary-foreground)" />
                ) : (
                  <span
                    className={`
                      text-sm md:text-base lg:text-lg font-semibold
                      ${isCurrent ? 'text-[var(--color-primary)]' : 'text-[var(--color-muted-foreground)]'}
                    `}
                  >
                    {stepNumber}
                  </span>
                )}
              </div>
              {/* Step Label */}
              <div className="mt-2 md:mt-3 lg:mt-4 text-center">
                <p
                  className={`
                    text-xs md:text-sm lg:text-base font-medium whitespace-nowrap
                    ${isCurrent ? 'text-[var(--color-foreground)]' : 'text-[var(--color-muted-foreground)]'}
                  `}
                >
                  {step?.label}
                </p>
                <p className="text-xs text-[var(--color-muted-foreground)] mt-1 hidden md:block">
                  {step?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;